import { Component, Input, OnInit } from "@angular/core";
import { AdvancedElementInterface } from "../../interfaces/advanced-element.interface";
import {
  BasicContactInformationControls,
  Keys,
} from "./basic-contact-information.controls";

@Component({
  selector: "fpt-basic-contact-information",
  templateUrl: "./basic-contact-information.component.html",
  styleUrls: ["./basic-contact-information.component.scss"],
})
export class BasicContactInformationComponent
  extends BasicContactInformationControls
  implements OnInit
{
  @Input()
  component!: AdvancedElementInterface;
  get ControlKeys() {
    return Keys;
  }

  ngOnInit(): void {
    this.register(this.component);
  }

  //only number will be add
  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  get f() {
    return this.documentForm.controls;
  }
}
